import { useEffect } from 'react';
import Cookies from 'js-cookie';


export const useVersionCheck = () => {


    const currentVersion = process.env.REACT_APP_VERSION;
    useEffect(() => {
        const checkVersion = async () => {
            try {
                const response = await fetch(`/version.json?v=${Date.now()}`, {
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache',
                        'Expires': '0',
                    }
                });
                if (!response.ok) return;

                const data = await response.json();
                const serverVersion = data.version;
                console.log('Current Version:', currentVersion);
                console.log('Server Version:', serverVersion);

                if (serverVersion && serverVersion !== currentVersion) {

                    console.log(
                        `Version mismatch detected: Client ${currentVersion} vs Server ${serverVersion}`
                    );

                    // Prevent infinite reload loop
                    const alreadyReloaded = sessionStorage.getItem('version-reloaded');

                    if (!alreadyReloaded) {

                        sessionStorage.setItem('version-reloaded', 'true');

                        setTimeout(() => {

                            localStorage.removeItem("companyInfo");
                            localStorage.removeItem("rzp_checkout_anon_id");
                            localStorage.removeItem("companyId");

                            Cookies.remove("authToken");
                            if ('caches' in window) {
                                caches.keys().then((names) => {
                                    names.forEach((name) => caches.delete(name));
                                });
                            }

                            window.location.href = window.location.origin;

                        }, 2000);
                    }
                }
                else {
                    // Clear flag when versions match
                    sessionStorage.removeItem('version-reloaded');
                }
            } catch (error) {
                console.error('Failed to check version:', error);
            }
        };

        checkVersion();
        const intervalId = setInterval(checkVersion, 5 * 60 * 1000);

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkVersion();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [currentVersion]);
};